function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Vrstva_3"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Vrstva_2"
}, React.createElement("g", null, React.createElement("path", {
  d: "M801.5,500H785c-0.003,39.396-7.975,76.842-22.39,110.93c-21.62,51.124-57.78,94.674-103.275,125.406 C613.828,767.068,559.082,784.993,500,785c-39.396-0.003-76.842-7.975-110.93-22.39c-51.124-21.62-94.674-57.78-125.407-103.275 C232.932,613.828,215.007,559.082,215,500c0.002-39.396,7.975-76.842,22.39-110.93c21.62-51.124,57.78-94.674,103.275-125.407 C386.172,232.932,440.917,215.007,500,215c39.396,0.002,76.842,7.975,110.93,22.39c51.124,21.62,94.674,57.78,125.406,103.275 C767.068,386.172,784.993,440.917,785,500H801.5H818c0.002-43.861-8.898-85.731-24.997-123.785 c-24.15-57.089-64.45-105.61-115.194-139.896C627.075,202.033,565.803,181.993,500,182c-43.861-0.002-85.731,8.898-123.785,24.997 c-57.089,24.15-105.61,64.451-139.896,115.195C202.033,372.925,181.993,434.197,182,500 c-0.002,43.861,8.898,85.731,24.997,123.785c24.15,57.089,64.451,105.61,115.195,139.896C372.925,797.967,434.197,818.007,500,818 c43.861,0.002,85.731-8.898,123.785-24.997c57.089-24.15,105.61-64.45,139.896-115.194C797.967,627.075,818.007,565.803,818,500 H801.5z"
})), React.createElement("path", {
  d: "M615.359,395.023L511.667,291.331c-6.443-6.443-16.891-6.443-23.334,0L384.64,395.023 c-6.443,6.444-6.443,16.712,0,23.156c6.444,6.443,16.891,6.821,23.335-0.179h0.058L483,343.449v353.552 c0,9.112,7.387,16.5,16.5,16.5c9.112,0,16.5-7.388,16.5-16.5V342.217l76.084,76.142c6.443,6.443,16.861,6.443,23.305,0 C621.833,411.915,621.804,401.468,615.359,395.023z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/custom-predlzenie-licencie.e732c5f0.svg";
export { SvgComponent as ReactComponent };